import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Opts } from "@ofqual/portal-core/core/types";
import { IntelligenceSource } from "../domain/IntelligenceSource";

export class IntelligenceSourcesService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<IntelligenceSource[]> {
    const url = `${this.apiRoot}/intelligencesources`;
    const intelligenceSources = await super.getRequest<IntelligenceSource[]>(
      url,
      opts
    );
    return intelligenceSources.sort((a, b) =>
      a.intelligenceSource < b.intelligenceSource ? -1 : 1
    );
  }
}
